import { render } from "./DataTable2.vue?vue&type=template&id=b04782c4&scoped=true"
import script from "./DataTable2.vue?vue&type=script&lang=js"
export * from "./DataTable2.vue?vue&type=script&lang=js"

import "./DataTable2.vue?vue&type=style&index=0&id=b04782c4&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04782c4"]])

export default __exports__